import { createFileRoute, notFound } from '@tanstack/react-router'

import { VitrineTokensPage } from '@/features/dev_tokens/vitrine-tokens-page'

// Vitrine de tokens: existe só em desenvolvimento, para comparar com o protótipo.
export const Route = createFileRoute('/dev/tokens')({
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- é assim que o TanStack Router pede
    if (!import.meta.env.DEV) throw notFound()
  },
  component: VitrineTokensPage,
})
